module.exports = __webpack_public_path__ + "media/YEAH_Scribble_Kopf_Matthias_480x480.2d4ab5a1.mp4";